<ng-container *ngIf="sharedService.isAdmin$ | async as isAdmin">
    <div *ngIf="isAdmin" class="border border-orange-500 relative rounded-sm">
        <div class="bg-orange-500 text-white text-xs absolute top-0 right-0 z-10 px-2 py-1 animate-pulse">Preview per
            amministratori
        </div>
        <ng-content></ng-content>

    </div>
</ng-container>